<script>
import {BTabs, BTab, BFormGroup, BFormInput} from 'bootstrap-vue'
import {i18nApi} from "@core/api";

export default {
    components: {BTabs, BTab, BFormGroup, BFormInput},
    props: {
        legalRole: {
            default() {
                return {
                    translations: {}
                };
            }
        }
    },
    data() {
        return {
            languages: [],
            value: this.legalRole.translations
        }
    },
    methods: {
        onChange() {
            this.$emit('input', this.value);
        }
    },
    created() {
        i18nApi.getLanguages().then(r => {
            this.languages = r.data
        });
    },
    watch: {
        legalRole() {
            this.value = this.legalRole.translations;
        }
    }
}
</script>

<template>
    <b-tabs>
        <b-tab
            v-for="language in languages"
            :title="language.code.toUpperCase()"
        >
            <b-form-group
                :label="$t('Component(Label):name')"
                :label-for="'name' + language.code"
            >
                <b-form-input
                    @input="onChange"
                    :id="'name' + language.code"
                    v-model="value[language.code].title"
                    :placeholder="$t('Component(Placeholder):name')"
                />
            </b-form-group>
        </b-tab>
    </b-tabs>
</template>
